import { css, styled } from '@styles/theme'

export const stylesSimulatedExam = {
	containerModal: css({
		h4: {
			_font: '$normal',
			fontSize: '$xl',
			lineHeight: '19px',
			color: '$neutral160',
		},
	}),

	containerInitExam: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		gap: 14,

		'@md': {
			flexDirection: 'row',
			gap: 0,
		},
	}),

	containerFlexRow: css({
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '14px',

		'@md': {
			flexDirection: 'row',
			gap: '32px',
		},
	}),

	TitleContainer: styled('div', {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		gap: '32px',
		marginTop: '19px',
		marginBottom: '32px',

		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',
			alignItems: 'center',
			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},

		variants: {
			isShowExam: {
				true: { marginTop: '19px', marginBottom: '18px' },
			},
		},
	}),

	ButtonItem: styled('button', {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		padding: '16px',
		minHeight: '57px',
		width: '100%',

		background: '$neutral10',
		borderRadius: '12px',
		border: '1px solid $neutral50',

		cursor: 'pointer',

		svg: { width: '20px', height: '20px', color: '$neutral100' },

		'&:hover': {
			h6: {
				color: '$blue20',
			},
			svg: {
				color: '$blue20',
			},
		},

		'@md': {
			width: '185px',
		},

		variants: {
			disabled: {
				true: {
					cursor: 'not-allowed',
					color: '$disabled',
					h6: {
						color: '$disabled',
					},

					'&:hover': {
						color: '$disabled',
						h6: {
							color: '$disabled',
						},
						svg: {
							color: '$disabled',
						},
					},
				},
			},
		},
	}),
}
